import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-questionnaire-question-proof-filter";

const keys = addTranslations(RESOURCE_NAME, {
    title: {
        en: "Missing documents",
        fr: "Documents manquants",
    },
    tooltip: {
        en: "Show only questions with missing required documents",
        fr: "Afficher uniquement les questions avec des documents requis manquants",
    },
});

export function useSupplierQuestionnaireQuestionProofFilterTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
